import { View } from 'pacto';
import { PactoHelper } from "../../../_utils/PactoHelper";
import { ConsoleDebug } from '../../../_utils/ConsoleDebug';

export class Link extends View {
  constructor(options) {
    super(options);

    this.logInstance = new ConsoleDebug('debug-link', 'Link');
    this.onClick = this.onClick.bind(this);
    this.pactoHelper = new PactoHelper();
  }

  render() {
    this.el.addEventListener('click', this.onClick);
  }

  onClick(event) {

    const { target } = event;
    const { href, title, dataset, parentNode } = target;

    const customObj = {
      target: target,
      href: href,
      title: title,
      dataset: dataset,
      parentNode: parentNode,
      triggerComponent: 'link'
    };

    let customEventType = 'customEventPiano:link';

    // WEB-538 special case for download links
    if ( target.getAttribute('download') !== "" )
    {
      customObj.download = target.getAttribute('download');
      customEventType = 'customEventPiano:link:download';
    }

    //event.preventDefault();
    const customEvent = new CustomEvent(customEventType, { detail: customObj });
    this.pactoHelper.triggerEvent(customEvent);
  }

}
